import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatSlideToggle, MatSlideToggleChange } from '@angular/material/slide-toggle';
import { EnpsControlComponent } from '@common/controls/enps-control/enps-control';

@Component({
    selector: 'st-toggle-control',
    imports: [FormsModule, MatSlideToggle],
    templateUrl: './toggle-control.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class ToggleControlComponent extends EnpsControlComponent<boolean> {
    public valueChanged(value: MatSlideToggleChange) {
        this.changed.emit(value.checked);
    }
}
